// extracted by css-extract-rspack-plugin
export default {"empty":"YM04PHxmqz0zLc7o"};